// components/scheduler/QueryServiceSelector.tsx
import React from 'react';
import { Form, Select, Spin, Typography } from 'antd';
import { QueryServiceInfo } from '@/shared/api/model';

const { Text } = Typography;
const { Option } = Select;

interface QueryServiceSelectorProps {
    services: QueryServiceInfo[];
    isLoading: boolean;
    value?: string;
    onChange: (value: string) => void;
}

const QueryServiceSelector: React.FC<QueryServiceSelectorProps> = ({
                                                                       services,
                                                                       isLoading,
                                                                       value,
                                                                       onChange
                                                                   }) => {
    const selectedService = services.find(s => s.name === value);

    return (
        <>
            <Form.Item
                name="queryServiceName"
                label="Notification Type"
                rules={[{ required: true, message: 'Please select a notification type' }]}
            >
                <Select
                    placeholder="Select notification type"
                    loading={isLoading}
                    value={value}
                    onChange={onChange}
                >
                    {services.map(service => (
                        <Option key={service.name} value={service.name}>
                            {service.displayName}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            {selectedService && (
                <Text type="secondary" className="block mb-4">
                    {selectedService.description}
                </Text>
            )}
        </>
    );
};

export default QueryServiceSelector;